import { render, staticRenderFns } from "./indepart.vue?vue&type=template&id=a3c8dab8&scoped=true"
import script from "./indepart.vue?vue&type=script&lang=js"
export * from "./indepart.vue?vue&type=script&lang=js"
import style0 from "./indepart.vue?vue&type=style&index=0&id=a3c8dab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c8dab8",
  null
  
)

export default component.exports